export const Direction = {
    DOWN: Symbol('DOWN'),
    INVALID: Symbol('INVALID'),
    LEFT: Symbol('LEFT'),
    RIGHT: Symbol('RIGHT'),
    UP: Symbol('UP')
};

export default Direction;
